




























































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { MedTransGoConstants } from '../../util/constants';
import { ApiRequest, QueryRecordsRequest, Document } from '../../types/request';
import { Attorney, ServiceRequest } from '../../types/entity';
import DataTable from '../../components/DataTable.vue';
import { CommonUtils } from '../../util/commonUtils';
import { DateUtils } from '../../util/dateUtils';
import { ResourceUtils } from '../../util/resourceUtils';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import UploadPatientLienDocumentModal from './UploadPatientLienDocumentModal.vue';
import ViewLienDocumentModal from './ViewLienDocumentModal.vue';
import { MemberProfile } from '@/types/response';

declare var Buffer: any;
// tslint:disable-next-line: no-var-requires
const TransportationTable = require('../../datatable/PatientTransportRequestsTable.json');
// tslint:disable-next-line: no-var-requires
const InterpretationTable = require('../../datatable/PatientInterpreterRequestsTable.json');
// tslint:disable-next-line: no-var-requires
const TelemedicineTable = require('../../datatable/PatientTelemedicineRequestsTable.json');
// tslint:disable-next-line:no-var-requires
const DeliveryTable = require('../../datatable/PatientDeliveryRequestsTable.json');
// tslint:disable-next-line:no-var-requires
const LienRequestDocumentTable = require('../../datatable/LienRequestDocumentTable.json');
@Component({
    props: {
        attorney: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            imagePreview: '',
        };
    },
    components: {
        DataTable,
    },
    methods: {
        formatDate(date: any) {
            return DateUtils.formatDate(date, DateUtils.FORMAT_DATETIME_AM_PM);
        },
    },
})
export default class ViewAttorneyModal extends Vue {
    private attorney: Attorney | undefined;
    private id: string = '';
    private show = true;
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private outputProperties = [
        'createdOn',
    ];

    public mounted() {
        this.attorney = this.$props.attorney;
        // this.id = this.$route.params.id;
        this.getAttorneyDetails(this.$route.params.id);
    }
    /**
     * @author <Pranav V. Bhawalkar>
     * @description - Returns attorney's details by attorney Id
     * @param req {Request} - Express Request - attorney Id
     * @param res {Response} - Express Response - attorney details
     * @returns attorney details
     * @throws InvalidRequestException if attorney id is invalid
     */
    private async getAttorneyDetails(attorneyId: string) {
        const iHttpService = ObjectFactory.getHttpService();
        const queryRecordsRequest: any = {
            conditions: [{
                conditions: [{
                    op: 'eq',
                    fieldName: 'organizationId',
                    value: this.memberProfile && this.memberProfile.organization ? this.memberProfile.organization.id : '',
                },
                {
                    op: 'eq',
                    fieldName: 'organizationId',
                    value: undefined,
                }],
                op: 'or',
            }],
        };
        queryRecordsRequest.conditions.push({
            fieldName: 'id',
            op: 'eq',
            value: attorneyId,
        });
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            data: queryRecordsRequest,
            url: `${MedTransGoConstants.HTTP_URL_ATTORNEY}/:attorneyId`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<any>(apiRequest);
        if (response.success && response.data) {
            this.attorney = response.data;
            this.show = true;
            const toastEvent: ToastEvent = {
                    message: CommonUtils.translateMessageCode('MSG_UPDATE_ATTORNEY'),
                    title: 'Success',
                    varient: 'success',
                    timeout: 5000,
                };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            CommonUtils.showError(response);
        }
    }

    private close() {
        this.$emit('close');
    }
}
